import { render } from "./AnggotaKeluarga.vue?vue&type=template&id=388b3904&scoped=true"
import script from "./AnggotaKeluarga.vue?vue&type=script&lang=js"
export * from "./AnggotaKeluarga.vue?vue&type=script&lang=js"

import "./AnggotaKeluarga.vue?vue&type=style&index=0&id=388b3904&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388b3904"]])

export default __exports__